import React from 'react';

function LoadingSpinner({ message = 'Loading…', fullScreen = false, size = 'md', className = '' }) {
  const sizeClass = size === 'sm' ? 'spinner-border-sm' : size === 'lg' ? 'spinner-border-lg' : '';

  const content = (
    <div className="text-center">
      <div className={`spinner-border text-primary ${sizeClass}`} role="status" />
      {message && <div className="mt-2 text-muted">{message}</div>}
    </div>
  );

  if (fullScreen) {
    return (
      <div
        className={`d-flex justify-content-center align-items-center ${className}`}
        style={{ position: 'fixed', inset: 0, background: 'rgba(255,255,255,0.8)', zIndex: 2000 }}
      >
        {content}
      </div>
    );
  }

  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`} style={{ minHeight: 120 }}>
      {content}
    </div>
  );
}

export default LoadingSpinner;

